export default "__VITE_ASSET__CwhANDHh__"